export const Type_Leave = 'C';
export const Type_Vacation = 'V';